/* GRP productkaarten: kleurrondjes wisselen de foto */
(function () {
  'use strict';
  function pick(dot) {
    var card = dot.closest('product-card');
    if (!card) return;
    card.querySelectorAll('.grp-card-sw__dot').forEach(function (d) { d.classList.toggle('is-active', d === dot); });
    var img = card.querySelector('.card-gallery img');
    if (img && dot.dataset.img) {
      if (dot.dataset.srcset) img.setAttribute('srcset', dot.dataset.srcset);
      img.setAttribute('src', dot.dataset.img);
    }
    if (dot.dataset.url) card.querySelectorAll('a[href]').forEach(function (a) { if (a.getAttribute('href').indexOf('/products/') !== -1) a.setAttribute('href', dot.dataset.url); });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.grp-card-sw__dot');
    if (!dot) return;
    e.preventDefault(); e.stopPropagation();
    pick(dot);
  }, true);
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('.grp-card-sw__dot');
    if (dot && window.matchMedia('(hover: hover)').matches) pick(dot);
  });
})();

/* V2: eigen snel-toevoegen venster */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var modal, state;
  function money(c) { try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100); } catch (e) { return '€' + (c / 100).toFixed(2).replace('.', ','); } }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function build() {
    modal = el('div', 'grp-qa');
    modal.setAttribute('hidden', '');
    modal.innerHTML = '<div class="grp-qa__backdrop" data-qa-close></div><div class="grp-qa__panel" role="dialog" aria-modal="true" aria-label="Snel toevoegen"><button type="button" class="grp-qa__close" data-qa-close aria-label="Sluiten">×</button><div class="grp-qa__media"><img alt=""></div><div class="grp-qa__body"><h3 class="grp-qa__title"></h3><div class="grp-qa__price"></div><div class="grp-qa__opts"></div><button type="button" class="grp-qa__add"></button><a class="grp-qa__more" href="#">Bekijk alle details</a><div class="grp-qa__done" hidden><strong>Toegevoegd aan je winkelwagen</strong><div class="grp-qa__done-btns"><a class="grp-qa__btn grp-qa__btn--dark" href="' + root + 'cart">Naar winkelwagen</a><button type="button" class="grp-qa__btn" data-qa-close>Verder winkelen</button></div></div></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-qa-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close(); });
    modal.querySelector('.grp-qa__add').addEventListener('click', add);
  }
  function close() { modal.setAttribute('hidden', ''); document.documentElement.classList.remove('grp-qa-open'); }
  function current() {
    var p = state.p;
    for (var i = 0; i < p.variants.length; i++) { var v = p.variants[i], ok = true; for (var k = 0; k < state.sel.length; k++) if (v.options[k] !== state.sel[k]) { ok = false; break; } if (ok) return v; }
    return null;
  }
  function render() {
    var p = state.p, v = current();
    modal.querySelector('.grp-qa__title').textContent = p.title;
    modal.querySelector('.grp-qa__price').textContent = money(v ? v.price : p.price);
    var src = (v && v.featured_image && v.featured_image.src) || p.featured_image;
    if (src) { var img = modal.querySelector('.grp-qa__media img'); img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800'; img.alt = p.title; }
    var box = modal.querySelector('.grp-qa__opts'); box.innerHTML = '';
    p.options.forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name; var values = (opt && opt.values) || [];
      if (p.variants.length === 1 && values.length <= 1) return;
      var g = el('div', 'grp-qa__group', '<div class="grp-qa__label"><span>' + esc(name) + '</span><span>' + esc(state.sel[i]) + '</span></div>');
      var row = el('div', 'grp-qa__vals');
      values.forEach(function (val) {
        var test = state.sel.slice(); test[i] = val;
        var avail = p.variants.some(function (x) { return x.available && x.options.every(function (o, k) { return o === test[k]; }); });
        var b = el('button', 'grp-qa__val' + (state.sel[i] === val ? ' is-on' : '') + (avail ? '' : ' is-out'), esc(val));
        b.type = 'button';
        b.addEventListener('click', function () { state.sel[i] = val; var m = current(); if (!m) { var alt = p.variants.filter(function (x) { return x.options[i] === val; }).sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); })[0]; if (alt) state.sel = alt.options.slice(); } render(); });
        row.appendChild(b);
      });
      g.appendChild(row); box.appendChild(g);
    });
    var btn = modal.querySelector('.grp-qa__add');
    btn.disabled = !(v && v.available);
    btn.textContent = v ? (v.available ? 'Toevoegen aan winkelwagen · ' + money(v.price) : 'Niet op voorraad') : 'Kies een uitvoering';
    modal.querySelector('.grp-qa__more').href = v ? state.url + '?variant=' + v.id : state.url;
  }
  function open(url) {
    if (!modal) build();
    state = null;
    modal.querySelector('.grp-qa__done').hidden = true;
    modal.querySelector('.grp-qa__add').hidden = false;
    modal.querySelector('.grp-qa__panel').classList.add('is-loading');
    modal.removeAttribute('hidden'); document.documentElement.classList.add('grp-qa-open');
    fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      state = { p: p, url: url, sel: first.options.slice() };
      modal.querySelector('.grp-qa__panel').classList.remove('is-loading');
      render();
    }).catch(function () { window.location.href = url; });
  }
  function add() {
    var v = current(); if (!v) return;
    var btn = modal.querySelector('.grp-qa__add'); btn.disabled = true; btn.textContent = 'Bezig...';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.grp-shop-header__cart-count, .cart-bubble__text-count, [data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = false; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.hidden = true; modal.querySelector('.grp-qa__done').hidden = false;
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Probeer opnieuw'; });
  }
  function qaGuard(e) {
    var b = e.target.closest && e.target.closest('quick-add-component button');
    if (!b || b.closest('quick-add-component').querySelector('form')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
  }
  ['pointerdown', 'pointerup', 'mousedown', 'mouseup'].forEach(function (t) { window.addEventListener(t, qaGuard, true); });
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('quick-add-component button');
    if (!b) return;
    var comp = b.closest('quick-add-component');
    if (comp.querySelector('form')) return;
    var card = b.closest('product-card');
    var a = card && card.querySelector('a[href*="/products/"]');
    if (!a) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var u = new URL(a.getAttribute('href'), window.location.origin);
    open(u.pathname);
  }, true);
})();
